// theme.js
import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  styles: {
    global: {
      // Apply styles globally for markdown content
      'h1, .markdown h1': {
        fontSize: '3xl', // You can use Chakra UI size tokens here
        fontWeight: 'bold',
        mt: 8,
        mb: 6,
      },
      'h2, .markdown h2': {
        fontSize: '2xl',
        fontWeight: 'semibold',
        mt: 6,
        mb: 4,
      },
      'h3, .markdown h3': {
        fontSize: 'xl', // Increase the font size for h3
        fontWeight: 'semibold',
        mt: 5,
        mb: 3,
      },
      'h4, .markdown h4': {
        fontSize: 'lg', // Increase the font size for h4
        fontWeight: 'medium',
        mt: 4,
        mb: 2,
      },
      'h5, .markdown h5': {
        fontSize: 'md', // Adjust the font size for h5 if needed
        fontWeight: 'medium',
      },
      'h6, .markdown h6': {
        fontSize: 'sm', // Adjust the font size for h6 if needed
        fontWeight: 'medium',
      },
      'p, .markdown p': {
        fontSize: 'md', // Increase the font size for paragraph text
        mt: 3, // Increase the margin for more spacing
        mb: 3,
      },
      'a, .markdown a': {
        color: 'teal.500',
        textDecoration: 'underline',
      },
      'ul, .markdown ul': {
        pl: 4,
        mt: 2,
        mb: 2,
      },
      'ol, .markdown ol': {
        pl: 4,
        mt: 2,
        mb: 2,
      },
      'li, .markdown li': {
        mt: 1,
      },
      // Add other global styles for markdown elements as needed
    },
  },
  // Your existing theme configuration (colors, components, etc.)
  colors: {
    brand: {
      50: '#e3f2fd',
      100: '#bbdefb',
      200: '#90caf9',
      300: '#64b5f6',
      400: '#42a5f5',
      500: '#2196f3',
      600: '#1e88e5',
      700: '#1976d2',
      800: '#1565c0',
      900: '#0d47a1',
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
      },
    },
    Text: {
      baseStyle: {
        fontWeight: 'bold',
      },
    },
  },
});

export default theme;
